export default __webpack_public_path__ + "static/ocean3-f0fdfa93d91c8246b1700d068482d524.jpg";